import { useState, useEffect } from 'react';
import shopApi from '@services/shop';

export const useShopInitialisation = (isLoaded, navigate, setStep1Completed, setAddressDetails, setFormData) => {
	const [currentShop, setCurrentShop] = useState(null);
	const [initializing, setInitializing] = useState(true);

	useEffect(() => {
		if (isLoaded) {
			shopApi
				.getMyShops()
				.then((shops) => {
					if (shops && shops.length > 0) {
						const unifyShops = shops.filter((shop) => shop.plan?.startsWith('unify'));

						if (unifyShops.length > 0) {
							const latestShop = unifyShops[unifyShops.length - 1];

							setCurrentShop(latestShop);

							// Mark step 1 as completed if shop has basic details filled in
							const hasBasicDetails = latestShop.name && latestShop.address && latestShop.postcode;

							if (hasBasicDetails) {
								// Split combined address back into addressLine1 and addressLine2
								// Backend stores as: "44 Northumberland St, London"
								const addressParts = latestShop.address ? latestShop.address.split(', ') : [];
								const addressLine1 = addressParts[0] || '';
								const addressLine2 = addressParts.length > 1 ? addressParts.slice(1).join(', ') : '';

								// Parse geolocation if it's a string (backend JSON.stringify's it)
								let geolocation = latestShop.geolocation;
								if (typeof geolocation === 'string') {
									try {
										geolocation = JSON.parse(geolocation);
									} catch (e) {
										geolocation = undefined;
									}
								}

								// ALWAYS populate addressDetails if shop has basic info
								// This fixes Step 1 showing empty after returning from Step 3 OAuth
								setAddressDetails({
									name: latestShop.name,
									addressLine1,
									addressLine2,
									city: latestShop.city,
									postcode: latestShop.postcode,
									country: latestShop.country,
									publicPhoneNumber: latestShop.publicPhoneNumber,
									googlePlaceId: latestShop.googlePlaceId,
									geolocation,
									openingHours: latestShop.openingHours,
									types: latestShop.types
								});

								setFormData((prev) => ({
									...prev,
									name: latestShop.contactName || prev.name,
									email: latestShop.contactEmail || prev.email
								}));

								// If shop has basic details saved, Step 1 is completed
								setStep1Completed(true);
							}
						}
					}
				})
				.catch(() => {
					// Silently handle error
				})
				.finally(() => {
					setInitializing(false);
				});
		}
	}, [isLoaded, setStep1Completed, setAddressDetails, setFormData]);

	return { currentShop, setCurrentShop, initializing };
};
